export default __webpack_public_path__ + "static/media/Girdle of the Tireless Defender.ac089a13.jpg";